interface Prop {
  <K extends string>(key: K): {
    <O extends Record<string, unknown>>(obj: O): O[K],
    <O extends Record<string, unknown>>(obj?: O): undefined
  }
}

const prop: Prop = (key) => <O extends Record<string, unknown>>(obj?: O) => obj ? obj[key] : undefined;

export default prop;
